import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('claim');

export const SET_CLAIM_TYPE = getActionName('SET_CLAIM_TYPE');
export const SET_READ_ONLY = getActionName('SET_READ_ONLY');
export const SET_DEFERRED_CONTRACTS = getActionName('SET_DEFERRED_CONTRACTS');
export const SET_REFERENCE = getActionName('SET_REFERENCE');
export const CLAIM_UPDATED = getActionName('CLAIM_UPDATED');
